<template>
  <div class="km__modules__colorvorschlag km__popup">
    <button class="km__button--back" type="button" name="back" @click="closePopup"></button>
    <button class="km__button--close" type="button" name="close" @click="closePopup"></button>
    <div class="km__popup--heading">
      <h2>{{ $t("konf_farbvorschlaege") }}</h2>
    </div>
    <div class="km__popup--content">
      <div class="intro" v-html="$t('konf_farbvorschlag_uebernehmen')"></div>
      <ul class="km__list--modules">
        <li class="km__list__element--modules">
          Farb Block
        </li>
        <li class="km__list__element--modules">
          Farb Block
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useStore} from "vuex";
import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import {useI18n} from "vue-i18n";


const store = useStore();
const i18n = useI18n();
const closePopup = () => store.commit("SET_OVERLAY_CLOSED", OverlayNames.farbvorschlag);

</script>

<style scoped lang="scss">
.km__modules__colorvorschlag {
  z-index: 999;
  overflow-y: scroll;

  .intro {
    margin-bottom: 40px;
    text-align: center;
    font-size: 12px;
    line-height: 17px;
    padding: 0 30px;
  }
}

:deep(.intro span) {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzMzMzMzO30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSIxNS42LDUzLjcgMTUuNiw2MS43IDMwLjUsNjEuNyAxMS42LDgwLjcgMTcuMiw4Ni4zIDM2LjIsNjcuMyAzNi4yLDgzLjYgNDQuMiw4My42IDQ0LjIsNTMuNyAJCSIvPg0KCQk8Zz4NCgkJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik05MC4xLDIxLjZjMCwwLTI3LjItMTAuNC0yOC0xMC43bC0yLjctMS4xbC0xLjEsMi43YzAsMC4xLTIuMSw1LjEtOC4yLDUuMWMwLDAtMC4xLDAtMC4xLDANCgkJCQljLTUuOSwwLTguMS00LjktOC4xLTUuMWwtMS4xLTIuN2wtMi43LDEuMWMtMC44LDAuMy0yOCwxMC43LTI4LDEwLjdsLTIuNiwxbDYuMywyMi4zbDE0LjEtNC45YzAsMSwwLDIuMiwwLDMuMg0KCQkJCWMwLDAuOCwwLDEuNywwLDIuNWg2YzAtMC45LDAtMS43LDAtMi41YzAtNC40LDAtNi43LTAuMy04bC0wLjctMy4zbC0xNS4xLDUuMmwtMy4xLTEwLjljNS40LTIuMSwxNy44LTYuOCwyMy4xLTguOA0KCQkJCWMxLjksMi42LDUuNiw2LjIsMTIuMiw2LjJjMC4xLDAsMC4yLDAsMC4yLDBjNi41LDAsMTAuMy0zLjYsMTIuMi02LjJjNS4yLDIsMTcuNyw2LjcsMjMuMSw4LjhsLTMuMSwxMC45bC0xNS4xLTUuMmwtMC43LDMuMw0KCQkJCWMtMC4zLDEuMy0wLjMsMy42LTAuMyw4YzAsMi4zLDAsNS0wLjEsNy4zYy0wLjEsMy4zLTAuMiwxNC41LTAuMiwxNy43Yy0xLjIsMS43LTUuNCw2LjktMTMuNyw3Ljd2NmMxMy40LTEsMTkuMS0xMSwxOS4zLTExLjUNCgkJCQlsMC40LTAuN2wwLTAuOGMwLTAuMSwwLjEtMTQuNiwwLjItMTguNGMwLjEtMi41LDAuMS01LjEsMC4xLTcuNWMwLTEsMC0yLjIsMC0zLjJsMTQuMSw0LjlsNi4zLTIyLjNMOTAuMSwyMS42eiIvPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=');
  position: relative;
  top: 7px;
}
</style>
